import { api } from '@/services/http.service';
import { defineStore } from 'pinia';
import { showErrorNotification } from '@/utils/show-notification.util';
import { ConditionListItem, ConditionListValueProperty } from '@/models/dictionary/condition-list.model';

interface ConditionListState {
  conditionList: ConditionListItem[];
  isConditionListLoading: boolean;
}

export const useConditionListStore = defineStore('ConditionListStore', {
  state: (): ConditionListState => ({
    conditionList: [],
    isConditionListLoading: false,
  }),
  getters: {
    excludeAndConditionList(state: ConditionListState): ConditionListItem[] {
      return state.conditionList.filter(({ value }: ConditionListItem) => value !== ConditionListValueProperty.AND);
    },
  },
  actions: {
    setConditionListLoading(isLoading: boolean): void {
      this.isConditionListLoading = isLoading;
    },
    setConditionList(conditionList: ConditionListItem[]): void {
      this.conditionList = conditionList;
    },
    getConditionList(whitelabelSlug: string): Promise<ConditionListItem[]> {
      if (this.conditionList.length) {
        return Promise.resolve(this.conditionList);
      }

      this.setConditionListLoading(true);

      return api.dictionary.getConditionListRequest.perform(whitelabelSlug)
        .then((conditionList: ConditionListItem[]) => {
          this.setConditionList(conditionList);

          return conditionList;
        })
        .catch(error => {
          showErrorNotification(error);

          return [];
        })
        .finally(() => {
          this.setConditionListLoading(false);
        });
    },
  },
});
